import { render } from "./CompanyOnboarding.vue?vue&type=template&id=3cdc8af5"
import script from "./CompanyOnboarding.vue?vue&type=script&lang=js"
export * from "./CompanyOnboarding.vue?vue&type=script&lang=js"

import "./CompanyOnboarding.vue?vue&type=style&index=0&id=3cdc8af5&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__